import queryString from 'query-string';
import { call, select, put } from 'redux-saga/effects';

import { createStandaloneToast, theme } from '@frontend/legacy-components';

import { loginWithToken } from 'modules/auth/login/data/sagas';

import API from 'services/api';
import authService from 'services/authService';
import quoteService from 'services/quoteService';

import history from 'utils/browserHistory';

import * as APP from './app';
import * as SESSION from './session';
import * as SUPPLIER from './supplier';

const { toast } = createStandaloneToast({ theme });

export function* initRoot() {
  history.push(yield select(APP.selectors.getHomePage));
}

export function* initAuthLink({ location }) {
  try {
    const key = queryString.parse(location.search).key;
    const response = yield call(API.auth.loginWithKey, key);
    yield call(loginWithToken, response.token);
  } catch (error) {
    history.push('/login');
  }
}

export function* initSupplierDownload({ location }) {
  const token = queryString.parse(location.search).token;
  const group = yield select(SESSION.selectors.getActiveGroup);
  const response = yield call(
    authService.getSupplierFileUrl,
    group.locator,
    token,
  );
  window.location.href = response.url;
}

const REQUOTE_ERROR_CODES = {
  REQUOTE_TOKEN_USED: 'requote_token_used',
  INVALID_REQUOTE_TOKEN: 'invalid_requote_token',
};

export function* initRequote({ match, location }) {
  try {
    const quoteId = match.params.quoteId;
    const requoteToken = queryString.parse(location.search).token || undefined;
    // for backwards compatibility, requoteToken is optional
    const response = yield call(quoteService.copy, quoteId, requoteToken);
    if (response && response.quoteCopyNumber) {
      history.replace(`/quotes/edit/${response.quoteCopyNumber}`);
    }
  } catch (error) {
    console.error(error);
    if (error.message === REQUOTE_ERROR_CODES.REQUOTE_TOKEN_USED) {
      yield call(toast, {
        status: 'warning',
        title: 'Requote link already used',
        description:
          'This URL has already been used to create a new quote copy for requote.',
      });
    }
    history.replace('/');
  }
}

export function* initVerifyEmail() {
  try {
    const token = (yield select(APP.selectors.getRouterSearchParams)).key;
    return yield call(API.auth.verifyEmail, token);
  } catch (error) {
    return { error };
  }
}

export function* initTeam() {
  return yield call(SUPPLIER.sagas.getTeamMembers);
}

export function* initEditTeamMember({ match }) {
  return yield call(SUPPLIER.sagas.getTeamMember, match.params.teamMemberId);
}

export function* initCreateTeamMember() {
  return yield put(SUPPLIER.actions.initCreateTeamMember());
}
